import { render } from "./ServiceMultiselect.vue?vue&type=template&id=642f4cdc"
import script from "./ServiceMultiselect.vue?vue&type=script&lang=js"
export * from "./ServiceMultiselect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__